import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom'

function Footer(){
    return(
        <div className='footer-container'>
            <div className="footer-links">
                <div className="footer-link-wrapper">
                    <div className="footer-link-items">
                        <h2>Contact</h2>
                        <Link to='https://mail.google.com/mail/?view=cm&fs=1&to=kamsibenagu22@gmail.com&su=&body='>My Email</Link>
                        <Link to='https://github.com/kamC0des'>Github</Link>
                        <Link to='https://linkedin.com/in/kamsi-ben-agu'>LinkedIn</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Footer